<template>
  <div class="buy_sell">
    <div class="buy_sell_content content_auto">
      <div class="crumb_box">
        <div class="crumb_content" @click="jumpTo('/transaction')">
          <!-- <span >{{ $t('币币交易') }}</span> -->
          <span class="middle_arrow">‹</span>
          <span>{{ $t('买卖盘') }}</span>
        </div>
      </div>
      <div class="buysell_content">
        <div class="buy">
          <div class="header_box">{{ $t('买盘') }}</div>
          <div class="body_box">
            <div class="body_title">
              <div class="first"></div>
              <div class="price">{{ $t('买入价') }}</div>
              <div class="amount">{{ $t('买入量') }}</div>
              <div class="total">{{ $t('累计') }}</div>
            </div>
            <ul class="content_ul">
              <li
                class="content_li buy"
                v-for="(item, index) in buyHandicap"
                :key="index"
                :style="{
                  backgroundSize: `${
                    isNaN(item.n) ? 0 : (Number(item.n) / buyMaxTotal) * 100
                  }% 100%`,
                }"
              >
                <span class="buy_first">{{ $t('买') }}{{ index + 1 }}</span>
                <span class="price">{{ item.p | initFilter('--') }}</span>
                <span class="amount">{{ item.n | initFilter('--') }}</span>
                <span class="total">{{ item.l | initFilter('--') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="sell">
          <div class="header_box">{{ $t('卖盘') }}</div>
          <div class="body_box">
            <div class="body_title">
              <div class="first"></div>
              <div class="price">{{ $t('卖入价') }}</div>
              <div class="amount">{{ $t('卖出量') }}</div>
              <div class="total">{{ $t('累计') }}</div>
            </div>
            <ul class="content_ul">
              <li
                class="content_li sell"
                v-for="(item, index) in sellHandicap"
                :key="index"
                :style="{
                  backgroundSize: `${
                    isNaN(item.n) ? 0 : (Number(item.n) / sellMaxTotal) * 100
                  }% 100%`,
                }"
              >
                <span class="sell_first">{{ $t('卖') }}{{ index + 1 }}</span>
                <span class="price">{{ item.p | initFilter('--') }}</span>
                <span class="amount">{{ item.n | initFilter('--') }}</span>
                <span class="total">{{ item.l | initFilter('--') }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendWSPush } from '@/utils/webSocket'
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      buyHandicap: 100, // 盘口买盘数据
      sellHandicap: 100, // 盘口卖盘数据
      buyMaxTotal: 1,
      sellMaxTotal: 1,
    }
  },
  created() {
    sendWSPush({ channel: this.parameterizedTradingPair, language: 'zh' })
  },
  computed: {
    ...mapState({
      plateData: (store) => store.transaction.plateData,
    }),
    ...mapGetters(['parameterizedTradingPair']),
  },
  watch: {
    plateData(newData) {
      const sellData = newData.sale.reverse()
      const buyData = newData.buy
      this.sellMaxTotal = this.assembleHandicap(sellData)
      this.buyMaxTotal = this.assembleHandicap(buyData)
      this.sellHandicap = sellData
      this.buyHandicap = buyData
    },
  },
  methods: {
    jumpTo(p) {
      this.$router.push({ path: p })
    },
    // 组装盘口数据
    assembleHandicap(array) {
      let maxTotal = 0 // 累计买入或卖出总量
      if (array.length < 100) {
        const targetLength = 100 - array.length
        for (let j = 0; j < targetLength; j++) {
          array.push(['--', '--', '--'])
        }
      }
      for (const bar of array) {
        if (bar.n !== '--' && Number(bar.n) > maxTotal) {
          maxTotal = Number(bar.n)
        }
      }
      return maxTotal
    },
  },
}
</script>
<style lang="less" scoped>
.buy_sell {
  background: rgba(37, 42, 68, 1);
  overflow: hidden;
  .buy_sell_content {
    margin-top: 20px;
    padding-bottom: 60px;
    .crumb_box {
      padding: 15px 30px;
      border-radius: 10px;
      background: rgba(19, 22, 37, 1);
      .crumb_content {
        font-size: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        cursor: pointer;
        .middle_arrow {
          margin-right: 20px;
        }
      }
    }
    .buysell_content {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      .buy,
      .sell {
        width: 100%;
        .header_box {
          padding: 9px 34px;
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          color: rgba(255, 255, 255, 1);
          border-radius: 10px 10px 0px 0px;
          background: rgba(8, 17, 38, 1);
        }
        .body_box {
          .body_title,
          .content_ul .content_li {
            padding: 7px 0 6px;
            height: 30px;
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;
            background: rgba(19, 22, 37, 1);
            div {
              font-size: 12px;
              font-weight: 400;
              color: rgba(90, 95, 136, 1);
              line-height: 17px;
            }
            span {
              font-size: 14px;
              font-weight: 400;
              color: rgba(175, 184, 222, 1);
              line-height: 20px;
            }
            .buy_first {
              position: absolute;
              left: 4.77%;
              color: rgba(0, 192, 125, 1);
            }
            .sell_first {
              position: absolute;
              left: 4.77%;
              color: rgba(255, 63, 74, 1);
            }
            .price {
              position: absolute;
              right: 60.45%;
            }
            .amount {
              position: absolute;
              right: 35.45%;
            }
            .total {
              position: absolute;
              right: 11.14%;
            }
          }
          .content_ul .content_li.buy {
            background-image: linear-gradient(
              rgba(22, 43, 52, 1),
              rgba(22, 43, 52, 1)
            );
            background-size: 0% 100%;
            background-position: 100% 100%;
            background-repeat: no-repeat;
          }
          .content_ul .content_li.sell {
            background-image: linear-gradient(
              rgba(45, 32, 47, 1),
              rgba(45, 32, 47, 1)
            );
            background-size: 0% 100%;
            background-position: 100% 100%;
            background-repeat: no-repeat;
          }
          .content_li:last-child {
            border-radius: 0 0 10px 10px;
          }
        }
      }
      .buy {
        margin-right: 40px;
      }
    }
  }
}
</style>
